// Phase configuration for the RPG narrative state machine.
// Each phase maps to a dialogue phase (backend) and a 3D scene "mode".

export const PHASES = [
  "impact",
  "acoustic",
  "flashlight",
  "wristlock",
  "stairwell",
  "descent",
  "exit",
];

// Which 3D diorama each phase uses.
export const SCENE_MODE = {
  impact: "prologue",
  acoustic: "acoustic",
  flashlight: "acoustic",
  wristlock: "acoustic",
  stairwell: "stairwell",
  descent: "stairwell",
  exit: "arrival",
};

// The interaction task shown for each phase, per POV.
export const PHASE_TASKS = {
  impact: {
    stanley: { label: "Take Cover Under the Desk", verb: "Seek shelter" },
    brian: { label: "Enter Stairwell A Landing", verb: "Move to landing" },
    title: "Impact Response",
    narration:
      "When faced with an incoming impact in a high-rise, every second counts. Observe positioning, then seek cover.",
  },
  acoustic: {
    stanley: { label: "Emit Wall Vector", verb: "Strike the drywall" },
    brian: { label: "Listen for the Sound Origin", verb: "Localize the sound" },
    title: "Acoustic Localization",
    narration:
      "In zero-visibility environments, sound waves replace visual anchors. Strike the load-bearing wall to project acoustic vibrations.",
  },
  flashlight: {
    stanley: { label: "Hold Signal Steady", verb: "Steady the signal" },
    brian: { label: "Lock Flashlight Onto Sound", verb: "Align the beam" },
    title: "Vector Alignment",
    narration:
      "Align the flashlight beam with the origin point of the acoustic waves behind the wall. Drag to aim, or lock automatically.",
  },
  wristlock: {
    stanley: { label: "Hold to Reach & Pull", verb: "Grip wrist-to-wrist" },
    brian: { label: "Hold to Reach & Pull", verb: "Grip wrist-to-wrist" },
    title: "The Mechanical Rescue Pull",
    narration:
      "Establish a wrist-to-wrist lock to maximize mechanical advantage, and pull over the barrier.",
  },
  stairwell: {
    stanley: { label: "Choose Stairwell A · Descend", verb: "Route down" },
    brian: { label: "Choose Stairwell A · Descend", verb: "Route down" },
    title: "Egress Vector Selection",
    narration:
      "While others climbed toward the roof, test the route going down. Route into Stairwell A — the only viable conduit.",
  },
  descent: {
    stanley: { label: "Hold W / DESCEND", verb: "Descend the stairs" },
    brian: { label: "Hold W / DESCEND", verb: "Descend the stairs" },
    title: "Continuous Egress",
    narration:
      "Trace the green clearance vector down through the intact core. One floor at a time — keep moving.",
  },
  exit: {
    stanley: { label: "Run to the Plaza", verb: "Clear the building" },
    brian: { label: "Run to the Plaza", verb: "Clear the building" },
    title: "Street Level",
    narration: "Clear the structure. Reach the plaza before the tower comes down.",
  },
};

// Timer: 56 historical minutes (3360s) compressed into 8 real minutes (480s).
export const SIM_TOTAL = 3360; // sim seconds (56 min)
export const REAL_TOTAL = 480; // real seconds (8 min)
export const SIM_RATE = SIM_TOTAL / REAL_TOTAL; // 7 sim-sec per real-sec
export const DECAY_THRESHOLD = 600; // sim seconds (10 min) remaining

export function formatSim(seconds) {
  const s = Math.max(0, Math.ceil(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}
